export const buttons = {
    back: "Back",
    next: "Next",
    submit: "Submit Application"
}